document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.sonlight-accordion-header');

  // Function to update accordion content height
  function updateAccordionHeight(content, tryAgain = true) {
    setTimeout(() => {
      if (content && content.previousElementSibling.getAttribute('aria-expanded') === 'true') {
        const innerContent = content.querySelector('.sonlight-accordion-content-inner');
        if (innerContent) {
          // Get the current height
          const startHeight = content.offsetHeight;

          // Temporarily remove the transition
          content.style.transition = 'none';

          // Set height to auto to measure full height
          content.style.height = 'auto';
          const targetHeight = content.offsetHeight;

          // Reset to start height
          content.style.height = startHeight + 'px';

          // Force a reflow
          content.offsetHeight;

          // Restore the transition
          content.style.transition = 'height 0.3s ease-out';

          // Animate to the target height
          content.style.height = targetHeight + 'px';

          if (tryAgain) {
            updateAccordionHeight(content, false);
          }
        }
      }
    }, 200);
  }

  // Create mutation observer for content changes
  const contentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Find the closest accordion content container
      const accordionContent = mutation.target.closest('.sonlight-accordion-content');
      if (accordionContent) {
        updateAccordionHeight(accordionContent);
      }
    });
  });

  // Observe each accordion content area
  document.querySelectorAll('.sonlight-accordion-content-inner').forEach(content => {
    contentObserver.observe(content, {
      childList: true,      // Watch for changes to child elements
      subtree: true,        // Watch all descendants, not just direct children
      characterData: true,  // Watch for text content changes
      attributes: true      // Watch for attribute changes
    });
  });

  // Handle anchor links on page load
  // if (window.location.hash) {
  //   const targetAccordion = document.querySelector(window.location.hash);
  //   if (targetAccordion) {
  //     const header = targetAccordion.querySelector('.sonlight-accordion-header');
  //     if (header) {
  //       setTimeout(() => {
  //         header.click();
  //         targetAccordion.scrollIntoView({ behavior: 'smooth' });
  //       }, 100);
  //     }
  //   }
  // }

  // Updated accordion click handler
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const accordionItem = this.closest('.sonlight-accordion-item'); // Reference to the accordion item

      // Close all other accordions
      accordionHeaders.forEach(otherHeader => {
        if (otherHeader !== this) {
          otherHeader.setAttribute('aria-expanded', 'false');
          const otherContent = otherHeader.nextElementSibling;
          otherContent.style.height = '0';
          otherContent.setAttribute('aria-hidden', 'true');
        }
      });

      // Toggle current accordion
      this.setAttribute('aria-expanded', !isExpanded);
      content.setAttribute('aria-hidden', isExpanded);

      if (!isExpanded) {
        // Opening the accordion
        const innerContent = content.querySelector('.sonlight-accordion-content-inner');
        const targetHeight = innerContent.offsetHeight;

        content.style.height = '0';
        content.offsetHeight; // Force reflow
        content.style.height = targetHeight + 'px';

        // // Scroll to the top of the accordion item after the animation
        // setTimeout(() => {
        //   accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //   // window.scrollBy(0, 50);
        // }, 300); // Match the 0.3s transition duration

        // Update URL hash
        const accordionId = accordionItem.id;
        history.pushState(null, null, `#${accordionId}`);
      } else {
        // Closing the accordion
        content.style.height = content.offsetHeight + 'px';
        content.offsetHeight; // Force reflow
        content.style.height = '0';
      }
    });
  });

  // Handle dynamic content changes from external sources (e.g., AJAX)
  function handleDynamicChanges() {
    accordionHeaders.forEach(header => {
      const content = header.nextElementSibling;
      if (header.getAttribute('aria-expanded') === 'true') {
        updateAccordionHeight(content);
      }
    });
  }

  // Listen for potential dynamic content triggers
  window.addEventListener('resize', handleDynamicChanges);
  document.addEventListener('shopify:section:load', handleDynamicChanges);
  document.addEventListener('shopify:block:select', handleDynamicChanges);

  // Optional: Handle images loading which might change content height
  document.querySelectorAll('.sonlight-accordion-content img').forEach(img => {
    img.addEventListener('load', () => {
      const accordionContent = img.closest('.sonlight-accordion-content');
      if (accordionContent) {
        updateAccordionHeight(accordionContent);
      }
    });
  });
});